import { participantFunctionsDSP } from '@openx/components-deal/lib/utils/participantFunctions.ts';

export const useParticipantFunctions = () => {
  return participantFunctionsDSP;
};
